import moment from 'moment';
import EditComentario from '../../jobs/editor';
import React from 'react';
import styled from 'styled-components';
import { UserCircle } from 'styled-icons/boxicons-solid';
import { Edit } from 'styled-icons/material-sharp';
import { palette } from '../../../../system/styles/styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Tooltip } from '@material-ui/core';

const ArticleContainer = styled.article`
  width: 95%;
  margin-top: 24px;
  margin-left: auto;
  margin-right: auto;
  height: calc(100vh - 190px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.5em;
    height: 0.5em;
  }
  &::-webkit-scrollbar-track {
    background-color: #f2f2f2;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 0.5rem;
  }
  label {
    margin-top: 10px;
    font-size: 16px;
    margin-bottom: 10px;
    font-family: ${palette.nereg};
  }
  button {
    padding: 5px 20px;
    margin: 5px;
    font-size: 14px;
    color: ${palette.white};
    font-family: ${palette.nereg};
    border: none;
    border-radius: 10px;
    background-color: ${palette.blue};
    cursor: pointer;
  }
  article {
    margin-bottom: 20px;
  }
  article h1 {
    font-size: 12px;
    font-family: ${palette.nereg};
  }
  article p {
    font-size: 10px;
  }
  article strong {
    padding: 5px 10px;
    border-radius: 2.5px;
    background-color: ${palette.blue};
    color: ${palette.white};
  }
  .invite {
    justify-content: flex-start !important;
  }
  .invite-admin {
    margin-left: 15%;
  }
  .Other {
    width: 85%;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    label {
      margin: 0px 0px 2px 10px;
      font-size: 16px;
    }
    p {
      margin: 0px;
      margin-left: 10px;
      font-size: 14px;
    }
  }
  .Other-admin {
    max-width: 100px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    height: 70px;
    align-self: self-end;
    label {
      grid-column: 1 / 3;
      margin: 0px 8px;
      font-size: 13px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    p {
      width: 40px;
      margin: 5px;
    }
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin: 5px;
    }
    button {
      padding: 0px;
    }
  }
  .Comment {
    max-width: 100%;
    position: relative;
    p {
      text-align: end;
      top: 100%;
      span {
        color: #a6a6a6;
        font-size: 12px;
        font-weight: 500;
        text-align: right;
      }
    }
    > div {
      padding: 20px;
      border-top-left-radius: 40px;
      border-top-right-radius: 40px;
      border-bottom-right-radius: 40px;
      max-width: 100%;
      width: fit-content;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 43px -8px;
      background-color: ${palette.black};
      p,
      ol > li,
      ul > li {
        font-size: 16px;
        color: ${palette.white};
        text-align: left;
        position: relative;
        margin: 0px;
      }
    }
  }
  .Comment-admin {
    p {
      text-align: left;
    }
    > div {
      border-top-left-radius: 40px;
      border-top-right-radius: 40px;
      border-bottom-left-radius: 40px;
      border-bottom-right-radius: 0px;
      background-color: ${palette.blue};
    }
  }
  .Moment button {
    margin: 0px 0px 2px 10px;
    padding: 0px;
    font-size: 14px;
    background-color: ${palette.blue};
    color: ${palette.white};
    cursor: pointer;
    padding: 5px 15px;
  }
  p {
    font-size: 14px;
  }
  .Comentarios-box {
    height: calc(100% - 287px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0.5em;
      height: 0.5em;
    }
    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0.5rem;
    }
  }
  .separador-fecha {
    font-size: 16px;
    font-weight: 500;
    padding: 20px 0px;
    text-align: center;
    color: #a6a6a6;
  }
  .ql-editor {
    max-height: 100px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0.5em;
      height: 0.5em;
    }
    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0.5rem;
    }
    > p,
    > ul,
    > ol,
    ol > li,
    ul > li {
      font-size: 14px !important;
      font-family: ${palette.nereg};
    }
  }
`;

const CommentsStep = (props) => {
  const {
    comments,
    _index,
    id,
    editComment,
    editdata,
    sendEditData,
    saveEditComment,
    data,
    sendData,
    sendComment,
    docID,
    idColumn,
    setStat,
    _updateEditable,
    _updateDataModal,
  } = props;

  const { t } = useTranslation(['applicant']);
  const user = useSelector((store) => store.auth.userData);
  return (
    <ArticleContainer>
      <label>{t('Question')}</label>
      <div>
        <EditComentario upstream={data} sendData={sendData} placeholder={''} />
      </div>
      <button
        type="button"
        onClick={() => {
          sendComment(data, docID, comments || true, idColumn);
          _updateDataModal('');
        }}>
        {t('Post')}
      </button>
      {comments ? (
        Object.values(comments)
          .reverse()
          .map((e, index, array) => {
            return _index.toString() !== index.toString() ? (
              <>
                {!index ? <p className="separador-fecha">{e.fecha}</p> : null}
                {index && e.fecha !== array[index - 1].fecha ? <p className="separador-fecha">{e.fecha}</p> : null}
                <div className={`Other ${user.email === e.email ? 'invite-admin' : 'invite'}`} key={index.toString()}>
                  {user.email !== e.email ? (
                    <div className="Other-admin">
                      <label>{e.userName || e.email}</label>
                      {user.email === e.email ? (
                        <button
                          type="button"
                          onClick={() => {
                            _updateEditable(e.comentario, index);
                          }}>
                          {t('Edit')}
                        </button>
                      ) : (
                        <div />
                      )}
                      {user.photo ? (
                        <img src={user.photo} alt={e.userName || e.email} />
                      ) : (
                        <Tooltip title={e.userName || e.email} placement="top" arrow>
                          <p>
                            <UserCircle color="#A9A" />
                          </p>
                        </Tooltip>
                      )}
                    </div>
                  ) : null}
                  <div className={`Comment ${user.email === e.email ? 'Comment-admin' : ''}`}>
                    <div dangerouslySetInnerHTML={{ __html: e.comentario }} />
                    <p>
                      <span>{moment(e.timestamp).format('h:mm:ss a')}</span>
                    </p>
                  </div>
                  {user.email === e.email ? (
                    <div className="Other-admin">
                      <label>{e.userName || e.email}</label>
                      {user.photoURL ? (
                        <img src={user.photoURL} alt={e.userName || e.email} />
                      ) : (
                        <Tooltip title={e.userName || e.email} placement="top" arrow>
                          <p>
                            <UserCircle color="#A9A" />
                          </p>
                        </Tooltip>
                      )}
                      {user.email === e.email ? (
                        <Tooltip title={t('EditComment')} placement="top" arrow>
                          <p
                            onClick={() => {
                              _updateEditable(e.comentario, index);
                            }}>
                            <Edit
                              color="#A9A"
                              width={20}
                              style={{
                                textAlign: 'center',
                                marginTop: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                              }}
                            />
                          </p>
                        </Tooltip>
                      ) : (
                        <div />
                      )}
                    </div>
                  ) : null}
                </div>
              </>
            ) : (
              <div>
                <EditComentario upstream={editdata} sendData={sendEditData} />
                <div>
                  <button
                    type="button"
                    onClick={() => {
                      saveEditComment(editdata, index);
                    }}>
                    {t('EditComment')}
                  </button>
                  <button type="button" onClick={() => editComment(-1)}>
                    {t('Cancel')}
                  </button>
                </div>
              </div>
            );
          })
      ) : (
        <p>{t('NoComments')}</p>
      )}
    </ArticleContainer>
  );
};

export default CommentsStep;
